import { useEffect } from "react";
import { useMemo } from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import { retrieveConvergencePageMenu } from "../../redux/slice/convergence/convergence-pages-menu-slice";
import { RootState, useAppDispatch } from "../../redux/store";
import LoadGRSAds from "../../components/advertisement/load-top-banner-ads";

const GRSConferenceHeader = () => {

  const dispatch = useAppDispatch()
  const path = "%2FGRS%2FSite-Nav";
  const { ConvergencePagesMenuData } = useSelector((state: RootState) => state.ConvergencePageMenu)
  const cachedGoogleAdsLoader = useMemo(() => <LoadGRSAds conferenceName="GRS" desktopId="div-gpt-ad-1740605282772-0" mobileId="div-gpt-ad-1740605229527-0" />, []);

  useEffect(() => {
    dispatch(retrieveConvergencePageMenu(path))
  }, [dispatch])

  return (
    <>
      {cachedGoogleAdsLoader}
      <header className="convergence-header sticky-top-off">
        <Navbar bg="dark" className="bg-primary navbar-dark fixed-top" expand="lg">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              {ConvergencePagesMenuData[0]?.navBarItemsList?.map((item, index) => {
                return (item.childNavigation?.length === 0) ? (
                  <Nav.Link href={item.url} key={index} target={item.isTargetBlank ? "_blank" : ""} dangerouslySetInnerHTML={{ __html: item.text }}></Nav.Link>
                ) : (
                  <NavDropdown id="nav-dropdown-dark-example" title={item.text} menuVariant="dark" key={index}>
                    {item.childNavigation?.map((itm, indx) => {
                      return <NavDropdown.Item href={itm.url} key={indx} target={itm.isTargetBlank ? "_blank" : ""} dangerouslySetInnerHTML={{ __html: itm.text }}></NavDropdown.Item>
                    })}
                  </NavDropdown>
                )
              })}
            </Nav>
          </Navbar.Collapse>
          <div className="form-inline">
            <a href="/grs/register" className="btn btn-success text-light mr-4" id="topRegisterBtn" role="button">Register</a>
            <a className="btn btn-primary" style={{ marginRight: 0 }} href="/">RAPS.ORG</a>
          </div>
        </Navbar>
      </header>
    </>
  );
};

export default GRSConferenceHeader;